import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useUpdateKycMutation } from '~/app/store/services'
import LeadForm from './user/LeadForm'
import { cancelNarration, speak, t } from '~/utils/narration'

export default function End({ webSocketRef, id, event_name }: any) {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [updateKyc] = useUpdateKycMutation()
  const [close, setClose] = useState(false)

  useEffect(() => {
    if (webSocketRef.current) {
      webSocketRef.current.close()
    }
    if (id) updateKyc({ token, id, status: 'recorded' })
    speak({
      en: `Congratulations! Your K Y C verification is complete. ${!event_name ? '' : 'Please provide your email address so I can send you the report.'}`,
      hi: `बधाई हो! आपका के वाई सी वेरिफ़िकेशन पूरा हो गया है। ${!event_name ? '' : 'कृपया अपना ईमेल पता दें ताकि आपको रिपोर्ट भेजी जा सके।'}`,
    })
    return () => cancelNarration()
  }, [])
  return (
    <Box pt={0}>
      <br />
      <img src="/images/success.gif" width="100px" />
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        {t({ en: 'Thank you!', hi: 'धन्यवाद!' })}
      </Typography>
      <Typography variant="subtitle1">
        {t({
          en: 'You have successfully completed the verification process!!',
          hi: 'आपने वेरिफ़िकेशन की प्रक्रिया सफलतापूर्वक पूरी कर ली है!!',
        })}
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        position="fixed"
        bottom="0%"
        // height="55%"
        width="100%"
        left={0}
        alignItems="center"
        zIndex={2}
        borderRadius="30px 30px 0 0"
        // padding="16px 24px"
        bgcolor="#FFF"
        boxShadow="0px -2px 15px 0px rgba(145, 158, 171, 0.24)"
      >
        {event_name && !close ? (
          <LeadForm id={id} onClose={() => setClose(true)} />
        ) : (
          <Box
            p={2}
            mt={2.5}
            mb={2.5}
            width="90%"
            textAlign="center"
            borderRadius="28px"
            bgcolor={'rgba(229, 223, 251, 1)'}
          >
            <img src="/images/logo.svg" style={{ width: 160, marginBottom: 20, marginTop: 10 }} />

            <Typography variant="h6" fontWeight="bold" pb={2}>
              IDENTITY PROOFING SOLUTIONS
            </Typography>
            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
              <div>
                {points.map((d) => (
                  <Stack key={d} direction="row" spacing={2} mb={1}>
                    <Typography component="li" variant="body1" gutterBottom>
                      {d}
                    </Typography>
                  </Stack>
                ))}
              </div>
            </Box>
            <Button fullWidth href="https://www.kriyam.ai/video-kyc" sx={{ mt: 2, mb: 1, py: 1.5 }}>
              {t({ en: 'Continue to website', hi: 'वेबसाइट पर जाएँ' })}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const points = [
  'Video KYC',
  'Field Verification',
  'Video Verification',
  'Face Match',
  'Document match',
]
